/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementCreateContentResponse } from './ContentManagementCreateContentResponse';

export type ContentManagementCreateContentResponseApiRespoonse = {
    data?: ContentManagementCreateContentResponse;
    status?: ContentManagementCreateContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementCreateContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

